import * as React from 'react';
import styled from '@emotion/styled';
import { style } from '../Shared/Style';

const Container = styled.div(
    (props: {
        background: string;
        width: string;
        margin: string;
        padding: any;
        justifyContent: string;
        alignItems: string;
    }) => ({
        borderRadius: style.roundCornerSize.small,
        padding: props.padding,
        width: props.width,
        display: 'flex',
        flexDirection: 'row',
        margin: props.margin,
        alignItems: props.alignItems,
        justifyContent: props.justifyContent
    })
);

// const Container = styled.div
//     border-radius: ${style.roundCornerSize.small}px;
//     padding: ${style.margin.l}px;
//     background: ${props => props.background};
// `;

interface Props {
    background?: string;
    children?: any;
    width?: string;
    margin?: string;
    padding?: any;
    alignItems?: string;
    justifyContent?: string;
}

export const AboveCard = (props: Props) => {
    return (
        <Container
            background={props.background || ''}
            width={props.width || ''}
            margin={props.margin || ''}
            padding={props.padding || ` 0px`}
            alignItems={props.alignItems || ''}
            justifyContent={props.justifyContent || ''}
        >
            {props.children}
        </Container>
    );
};
